import create from 'zustand'
import { persist } from 'zustand/middleware'
export const useAuthStore = create(
  persist(
    (set) => ({
      bearer: null, // access token
      idToken: null, // ID token
      isLoggedIn: false, // login status // set tokens and login status
      setAuth: ({ bearer, idToken }) => set({ bearer, idToken }), // clear tokens on logout
      clearAuth: () => set({ bearer: null, idToken: null }),
    }),
    {
      name: 'auth-storage', // key for localStorage
      partialize: (state) => ({
        bearer: state.bearer,
        idToken: state.idToken,
      }),
    }
  )
)
